import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import Highlight from './config/highlight.js'
import scui from './scui'
import i18n from './locales'
import router from './router'
import store from './store'
import { createApp } from 'vue'
import App from './App.vue'
import * as Icons from '@element-plus/icons-vue'

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(scui);
app.use(Highlight)
for (let i in Icons) {
    app.component(i, Icons[i])
  }
//挂载app
app.mount('#app');



